<template>
  <div class="activity-rule-container" 
    :style="{
      'background-image': !cc.background_color ? `url(${gc.section_bg.top}), url(${gc.section_bg.mid}), url(${gc.section_bg.bot})` : '',
      'background-color': cc.background_color,
      'border-radius': cc.border_radius + 'px',
      'margin-top': cc.margin_top + 'px' || gc.margin_top + 'px',
      'margin-bottom': cc.margin_bot + 'px' || gc.margin_bot + 'px',
    }">
    <h2 class="rule-title" v-if="cd.title" :style="{'color': gc.main_color, 'border-bottom': `1px solid ${hexToRgba(gc.main_color, 0.15)}`}">{{cd.title}}</h2>
    <div class="inner-title" v-if="cc.cpt_inner_title" :style="{'color': gc.main_color}">{{cc.cpt_inner_title}}</div>
    <ol 
    class="rule-list" 
    :style="{
      'padding': cd.title ? '14px 18px 20px 38px' : '24px 18px 24px 38px'
    }"
    >
      <li :style="{'color': gc.main_color, 'text-align': cc.align || 'left'}" v-for="item in cc.rule_list" :key="item">
        {{item}}
      </li>
    </ol>
  </div>
</template>

<script>
import { ComponentCommonMixin } from '../mixin';
export default {
  mixins: [ComponentCommonMixin],
}
</script>

<style lang="less" scoped>
.activity-rule-container {
  margin: 30px 14px;
  background-size: 100% 30px, 100% calc(100% - 60px), 100% 30px;
  background-repeat: no-repeat;
  background-position: center top, center center, center bottom;
  .rule-title {
    font-weight: 500;
    font-size: 14px;
    line-height: 28px;
    opacity: .75;
    padding: 10px 18px;
  }
  .inner-title {
    font-size: 14px;
    height: 20px;
    line-height: 20px;
    position: relative;
    top: 16px;
    left: 16px;
  }
  .rule-list {
    li {
      font-size: 13px;
      line-height: 22px;
      opacity: .8;
    }
  }
}
</style>